import { Typography } from '@mui/material'
import { t } from 'i18next'
import moment from 'moment-timezone'
import classNames from 'classnames/bind'
import styles from './NavbarFooter.module.scss'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { useEffect, useState } from 'react'
const version = require('~/version.txt')

const cx = classNames.bind(styles)
export const NavbarFooter = () => {
  const theme = useAppSelector(currentTheme)
  const [managerVersion, setManagerVersion] = useState('')

  useEffect(() => {
    fetch(version)
      .then(response => response.text())
      .then(text => {
        setManagerVersion(text)
      })
      .catch(error => console.error('Error loading the file:', error))
  }, [])
  return (
    <div className={cx('footer', theme)}>
      <Typography fontWeight={500}>v{managerVersion}</Typography>
      <div>
        {t('Message_tk0_CopyrightTaitCommunications_tk1', {
          0: '',
          1: moment().year()
        })}
      </div>
    </div>
  )
}
